import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnFR: CultureInfo = {
  name: 'en-FR',
  displayName: 'English (France)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-FR',
  parent: CultureInfoEn
};
